@switch (columnName) {
  @case ('status') {
    <mat-icon
      class="ptw-active-icon"
      [class.ptw-active-icon--inactive]="!element.isActive"
      [attr.aria-label]="(element.isActive ? 'active' : 'deactivated') | translate"
    >
      {{ element.isActive ? 'check' : 'pause' }}
    </mat-icon>
  }
  @case ('permitType') {
    {{ element.name }}
  }
  @case ('locationType') {
    {{ element.name }}
  }
  @case ('formLinked') {
    {{ linkedFormNames || '–' }}
  }
  @case ('relatedObjects') {
    @for (url of element.links ?? []; track url) {
      <div>{{ url }}</div>
    }
    @for (attachment of element.defaultAttachments ?? []; track attachment.id) {
      <div>{{ attachment.name }}</div>
    }
    @if (!element.links?.length && !element.defaultAttachments?.length) {
      <span>–</span>
    }
  }
  @case ('name') {
    <div class="ptw-table-name">
      {{ element.name }}
      @if (element.state === states.ForApproval) {
        <app-ui-pill name="expiring" [customLabel]="true">
          {{ 'ptw.awaitingApproval' | translate }}
        </app-ui-pill>
      } @else if (element.state === states.Rejected) {
        <app-ui-pill name="rejected" [customLabel]="true">
          {{ 'ptw.rejected' | translate }}
        </app-ui-pill>
      } @else if (element.urgency === 1 || element.urgency === 2) {
        <app-ui-pill [name]="urgencyLabels[element.urgency]"></app-ui-pill>
      }
    </div>
  }
  @case ('state') {
    <app-ui-pill
      [customLabel]="true"
      [name]="
        element.state === states.ForApproval
          ? 'expiring'
          : element.state === states.Pending
            ? 'ok'
            : element.state === states.Rejected
              ? 'rejected'
              : element.state === states.InProgress
                ? 'implementing'
                : 'archive'
      "
    >
      {{ 'ptw.state.' + states[element.state] | translate }}
    </app-ui-pill>
    @if (element.isProlonged) {
      <span class="ptw-prolonged-marker">{{ 'ptw.prolonged' | translate }}</span>
    }
  }
  @case ('isActive') {
    <mat-icon
      class="ptw-active-icon"
      [class.ptw-active-icon--inactive]="!element.isActive"
      [matTooltip]="(element.isActive ? 'active' : 'inactive') | translate"
    >
      {{ element.isActive ? 'check' : 'pause' }}
    </mat-icon>
    <span class="cdk-visually-hidden">
      {{ (element.isActive ? 'active' : 'inactive') | translate }}
    </span>
  }
  @case ('approvers') {
    {{ approverNames || '–' }}
  }
  @case ('defaultForms') {
    {{ linkedFormNames || '–' }}
  }
  @case ('documentation') {
    @for (attachment of element.defaultAttachments ?? []; track attachment.id) {
      <div>{{ attachment.name }}</div>
    }
    @for (url of element.links ?? []; track url) {
      <a [href]="url" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
        {{ url }}
      </a>
    }
    @if (!element.defaultAttachments?.length && !element.links?.length) {
      <span>–</span>
    }
  }
  @case ('urgency') {
    @if (element.urgency != null) {
      <app-ui-pill [name]="urgencyLabels[element.urgency]"></app-ui-pill>
    }
  }
  @case ('start') {
    {{ element.start | date: dateFormat }}
  }
  @case ('end') {
    {{ element.end | date: dateFormat }}
  }
  @default {
    {{ element[columnName] }}
  }
}
